<div class="thieme-grid mm-page">
  <h2 class="mb-4">{{_(KEYS.GRID.THIEME_CATALOG)}}</h2>

  <div class="alert alert-warning" *ngIf="incompatibleRemote">
    <i class="fa fa-exclamation-triangle mr-1"></i>
    {{_(KEYS.GRID.INCOMPATIBLE_REMOTE, {version: incompatibleRemote.version, schemaVersion: incompatibleRemote.requiredSchemaVersion})}}
  </div>

  <div class="card mb-5">
    <div class="card-body">
      <button type="button" class="card-title mm-pane-toggle"
              (click)="isSearchCollapsed = !isSearchCollapsed"
              [attr.aria-expanded]="!isSearchCollapsed" aria-controls="thieme-catalog-grid-search-fields">
        <span class="mm-pane-toggle-label">
          <i class="fa fa-search" aria-hidden="true"></i>
          <span>{{_(KEYS.GRID.SEARCH)}}</span>
        </span>
        <span class="mm-pane-toggle-icon" aria-hidden="true">
          <i class="fa" [ngClass]="{'fa-chevron-down': isSearchCollapsed, 'fa-chevron-up': !isSearchCollapsed}"></i>
        </span>
      </button>
      <div id="thieme-catalog-grid-search-fields" class="card-text" [ngbCollapse]="isSearchCollapsed">
        <div class="search-grid">
          <div class="search-field">
            <label>{{_(KEYS.GRID.FULLTEXT)}}</label>
            <input class="form-control" [(ngModel)]="filter.fulltext"
                   (paste)="onFilterChange()" (change)="onFilterChange()" (keydown)="onFilterChange()">
          </div>

          <div class="search-field">
            <label>{{_(KEYS.GRID.SPECIALTY)}}</label>
            <select class="form-control custom-select" [(ngModel)]="filter.specialty" (change)="onFilterChange()">
              <option value="">...</option>
              <option *ngFor="let specialty of specialties" [value]="specialty">{{specialty}}</option>
            </select>
          </div>

          <div class="search-field">
            <label>{{_(KEYS.GRID.BODY_REGION)}}</label>
            <select class="form-control custom-select" [(ngModel)]="filter.bodyRegion" (change)="onFilterChange()">
              <option value="">...</option>
              <option *ngFor="let bodyRegion of bodyRegions" [value]="bodyRegion">{{bodyRegion}}</option>
            </select>
          </div>

          <div class="search-field">
            <label>{{_(KEYS.GRID.FORM_TYPE)}}</label>
            <select class="form-control custom-select" [(ngModel)]="filter.formType" (change)="onFilterChange()">
              <option value="">...</option>
              <option *ngFor="let formType of formTypes" [value]="formType">{{formType}}</option>
            </select>
          </div>

          <div class="search-field">
            <label>{{_(KEYS.GRID.LANGUAGE)}}</label>
            <select class="form-control custom-select" [(ngModel)]="filter.language" (change)="onFilterChange()">
              <option value="">...</option>
              <option *ngFor="let code of languageCodes" [value]="code">{{translateLanguage(code)}}</option>
            </select>
          </div>

          <div class="search-field">
            <label>{{_(KEYS.GRID.DOWNLOAD_STATUS)}}</label>
            <select class="form-control custom-select" [(ngModel)]="filter.downloadStatus" (change)="onFilterChange()">
              <option value="">...</option>
              <option value="downloaded">{{_(KEYS.GRID.DOWNLOAD_STATUS_DOWNLOADED)}}</option>
              <option value="not-downloaded">{{_(KEYS.GRID.STATUS_NOT_DOWNLOADED)}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-body">
      <div class="card-title mm-pane-header" [class.mm-pane-collapsed]="isGridCollapsed">
        <div class="mm-pane-actions">
          <button class="btn btn-sm btn-success d-inline-block" (click)="onRefresh()">
              <i class="fa fa-refresh"></i>
            </button>
        </div>
        <button type="button" class="mm-pane-toggle"
                (click)="isGridCollapsed = !isGridCollapsed"
                [attr.aria-expanded]="!isGridCollapsed" aria-controls="thieme-catalog-grid-results">
          <span class="mm-pane-toggle-label"><span>{{_(KEYS.GRID.CATALOG)}}</span>
            <span class="text-muted ml-2" *ngIf="catalogVersion">{{_(KEYS.GRID.CATALOG_VERSION)}}: {{catalogVersion}}</span></span>
          <span class="mm-pane-toggle-icon" aria-hidden="true">
            <i class="fa" [ngClass]="{'fa-chevron-down': isGridCollapsed, 'fa-chevron-up': !isGridCollapsed}"></i>
          </span>
        </button>
      </div>
      <div id="thieme-catalog-grid-results" class="card-text" [ngbCollapse]="isGridCollapsed">
        <div class="table-scroll-container">
        <div class="mm-table-scroll"><table class="table">
          <thead>
          <tr>
            <th class="thieme-cursor-pointer" (click)="onSortChange('bogencode')">
              {{_(KEYS.GRID.BOGENCODE)}}
              <i *ngIf="filter.sort === 'bogencode' && filter.order === 'asc'" class="fa fa-arrow-up"></i>
              <i *ngIf="filter.sort === 'bogencode' && filter.order === 'desc'" class="fa fa-arrow-down"></i>
            </th>
            <th class="thieme-cursor-pointer" (click)="onSortChange('shortTitle')">
              {{_(KEYS.GRID.SHORT_TITLE)}}
              <i *ngIf="filter.sort === 'shortTitle' && filter.order === 'asc'" class="fa fa-arrow-up"></i>
              <i *ngIf="filter.sort === 'shortTitle' && filter.order === 'desc'" class="fa fa-arrow-down"></i>
            </th>
            <th class="thieme-cursor-pointer" (click)="onSortChange('specialty')">
              {{_(KEYS.GRID.SPECIALTY)}}
              <i *ngIf="filter.sort === 'specialty' && filter.order === 'asc'" class="fa fa-arrow-up"></i>
              <i *ngIf="filter.sort === 'specialty' && filter.order === 'desc'" class="fa fa-arrow-down"></i>
            </th>
            <th class="thieme-cursor-pointer" (click)="onSortChange('language')">
              {{_(KEYS.GRID.LANGUAGE)}}
              <i *ngIf="filter.sort === 'language' && filter.order === 'asc'" class="fa fa-arrow-up"></i>
              <i *ngIf="filter.sort === 'language' && filter.order === 'desc'" class="fa fa-arrow-down"></i>
            </th>
            <th>{{_(KEYS.GRID.VERSION)}}</th>
            <th class="text-center">{{_(KEYS.GRID.STATUS)}}</th>
            <th>{{_(KEYS.GRID.OPTIONS)}}</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let entry of entries; let pos = index">
            <tr [ngClass]="{'thieme-tr-odd': pos % 2 === 0}">
              <td class="nowrap">{{entry.bogencode || entry.sapId}}</td>
              <td>{{entry.shortTitle || entry.title}}</td>
              <td>{{entry.specialty}}</td>
              <td class="nowrap text-center">
                <span *ngIf="flagIconCodeMap[entry.language]; else langCode"
                      class="flag-icon flag-icon-{{flagIconCodeMap[entry.language]}}"
                      placement="top"
                      [ngbTooltip]="translateLanguage(entry.language)"></span>
                <ng-template #langCode>
                  <span placement="top" [ngbTooltip]="translateLanguage(entry.language)">{{entry.language}}</span>
                </ng-template>
              </td>
              <td class="nowrap">{{entry.editorialVersion}}</td>
              <td class="text-center">
                <i class="fa fa-circle"
                   [ngClass]="{
                     'thieme-status-not-downloaded': getStatus(entry) === 'not-downloaded',
                     'thieme-status-up-to-date': getStatus(entry) === 'up-to-date',
                     'thieme-status-update-available': getStatus(entry) === 'update-available'
                   }"
                   placement="top"
                   [ngbTooltip]="getStatusTooltip(entry)"></i>
              </td>
              <td>
                <button
                  class="btn btn-sm btn-primary d-inline-block"
                  (click)="onDownload(entry)"
                  placement="top"
                  [ngbTooltip]="_(KEYS.GRID.DOWNLOAD)"
                  [attr.disabled]="busy[entry.uuid] ? true : null">
                  <i class="fa" [ngClass]="{'fa-download': !busy[entry.uuid], 'fa-spinner fa-pulse fa-fw': busy[entry.uuid]}"></i>
                </button>
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table></div>
        </div>

        <div class="btn-toolbar justify-content-between mt-2 mb-2">
          <div class="justify-content-between">
            <div class="input-group thieme-num-per-page">
              <select class="form-control custom-select" [(ngModel)]="displayPerPage" (change)="onPagingChange()">
                <option value="2">2</option>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <span class="input-group-addon">{{_(KEYS.GRID.ENTRIES)}}</span>
            </div>
          </div>
          <ngb-pagination
            [pageSize]="displayPerPage"
            [maxSize]="9"
            [rotate]="true"
            [(page)]="gridPageNumber"
            [collectionSize]="total"
            (pageChange)="onPagingChange()">
          </ngb-pagination>
        </div>

      </div>
    </div>
  </div>
</div>
